function StockinfoConverter(props){
    
    return <>
        <span>{props.data.Stock_Name} {props.data.Qty} {props.data.Stock_Unit}</span>
        <br></br>
    </>
}

export default StockinfoConverter